export const omitFields = <T, K extends keyof T>(obj: T, keys: readonly K[]): Omit<T, K> => {
    const clone: any = { ...obj };
    for (const k of keys) delete clone[k];
    return clone;
};
